'use strict';

import { defaultAppState } from '../App/app.states';

export const signupRootState = {
	name: 'signupRoot',
	url: '/signup',
	data: {
		isAnonymous: true,
	},
	lazyLoad: async function (transition) {
		const $ocLazyLoad = transition.injector().get('$ocLazyLoad');
		const { signUpModule } = await import(/* webpackChunkName: "shell" */ './signup.module');
		await $ocLazyLoad.inject({
			rerun: true,
			reconfig: true,
			name: signUpModule.name,
		});

		const { shellAgentModule } = await import('../Shell/shell');
		await $ocLazyLoad.inject(shellAgentModule.name, {}, true);
	},
	redirectTo: async ($transition$) => {
		const authService = $transition$.injector().get('mx.shell.AuthService');
		return (await authService.isSignUpEnabled()) ? 'signup' : defaultAppState.name;
	},
};

export const signupState = {
	parent: signupRootState.name,
	name: 'signup',
	data: {
		isAnonymous: true,
	},
	component: 'signupForm',
};

export const signupVerificationState = {
	parent: signupRootState.name,
	name: 'signupVerification',
	data: {
		isAnonymous: true,
	},
	component: 'signupVerification',
};
